<template>
  <BaseDateTimePicker
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    @change="$emit('change', $event)"
    v-bind="$attrs"
  >
  </BaseDateTimePicker>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseDateTimePicker from './BaseDateTimePicker.vue';

export default defineComponent({
  components: { BaseDateTimePicker },
  props: ['modelValue'],
  emits: ['update:modelValue', 'change']
});
</script>